export default __webpack_public_path__ + "static/media/040_tunnel.last.5db5dabc.avif";